import { LOST_OVERALL_STATUSES } from "./constants";

export const generalLayout = [
  {
    row: [
      {
        label: "Case Name:",
        type: "text",
        name: "name",
        required: false,
      },
      {
        label: "Case Type:",
        type: "select",
        name: "incidentType",
        required: false,
        optionsURL: "field_options/?content_type=case&field_name=incident_type&ordering=order&",
      },
    ],
  },
  {
    row: [
      {
        label: "Incident Role:",
        type: "select",
        name: "incidentRole",
        required: false,
        optionsURL: "field_options/?content_type=case&field_name=incident_role&ordering=order&",
      },
      {
        label: "Incident State:",
        type: "select",
        name: "incidentLocation",
        required: true,
        optionsURL: "field_options/?content_type=case&field_name=incident_location&ordering=order&",
      },
      {
        label: "Incident City:",
        type: "select",
        name: "incidentCity",
        dependsOn: "incidentLocation",
        required: false,
        dynamicOptionsURL: (locationValue) =>
          `address/cities/?state=${locationValue}&ordering=name`,
      },
    ],
  },
  {
    row: [
      {
        label: "Medical Status:",
        type: "select",
        name: "status",
        historyToolTip: true,
        required: true,
        optionsURL: "field_options/?content_type=case&field_name=status&ordering=order&",
      },
      {
        label: "Legal Status:",
        type: "select",
        name: "legalStatus",
        historyToolTip: true,
        required: true,
        optionsURL: "field_options/?content_type=case&field_name=legal_status&ordering=order&",
      },
      {
        label: "Case Status:",
        type: "select",
        name: "overallStatus",
        historyToolTip: true,
        required: true,
        optionsURL: "field_options/?content_type=case&field_name=overall_status&ordering=order&",
        blockedValues: LOST_OVERALL_STATUSES,
      },
    ],
  },
  {
    row: [
      {
        label: "Date of Incident:",
        type: "date",
        name: "dateOfAccident",
        required: true,
      },
      {
        label: "Statute of Limitations:",
        type: "date",
        name: "statuteOfLimitations",
        readOnly: true,
        required: false,
      },
    ],
  },
];

export const coverageLayout = [
  {
    row: [
      {
        label: "Liability Status:",
        name: "liabilityStatus",
        historyToolTip: true,
        type: "select",
        required: false,
        optionsURL:
          "field_options/?content_type=clientcoverage&field_name=liability_status&ordering=order&",
      },
      {
        label: "Liability Note:",
        name: "liabilityNote",
        type: "textarea",
        required: false,
      },
    ],
  },
  {
    row: [
      {
        label: "Coverage Status:",
        name: "coverageStatus",
        historyToolTip: true,
        type: "select",
        required: false,
        optionsURL:
          "field_options/?content_type=clientcoverage&field_name=coverage_status&ordering=order&",
      },
      {
        label: "Coverage Note:",
        name: "coverageNote",
        type: "textarea",
        required: false,
        maxLength: 256,
      },
    ],
  },
  {
    row: [
      {
        label: "Liability Request Status:",
        name: "liabilityRequestStatus",
        historyToolTip: true,
        type: "select",
        required: false,
        optionsURL:
          "field_options/?content_type=clientcoverage&field_name=liability_request_status&ordering=order&",
      },
      {
        label: "Liability Request Email:",
        name: "liabilityRequestEmail",
        type: "email",
        required: false,
        hidden: true,
        maxLength: 256,
      },
    ],
  },
];

export const policyLayout = [
  {
    row: [
      {
        label: "Policy Limit Selection:",
        name: "policyLimitSelection",
        historyToolTip: true,
        type: "select",
        required: false,
        optionsURL: "field_options/?field_name=policy_limit_selection&ordering=order&",
      },
      {
        label: "Policy Limit Amount:",
        referenceName: "policyLimitAmount", // Needed to apply transformations
        name: "",
        type: "number",
        required: false,
        hidden: true,
      },
    ],
  },
  {
    row: [
      {
        label: "UM Selection:",
        name: "uninsuredMotoristSelection",
        historyToolTip: true,
        type: "select",
        required: false,
        optionsURL: "field_options/?field_name=uninsured_motorist_selection&ordering=order&",
      },
      {
        label: "UM Amount:",
        referenceName: "uninsuredMotorist", // Needed to apply transformations
        name: "",
        type: "number",
        required: false,
        hidden: true,
      },
    ],
  },
  {
    row: [
      {
        label: "Medical Pay:",
        name: "medicalPay",
        type: "number",
        required: false,
      },
      {
        label: "Personal Injury Protection:",
        name: "personalInjuryProtection",
        type: "number",
        required: false,
      },
      {
        label: "Medical Limits Available:",
        name: "medicalLimit",
        type: "number",
        required: false,
        disabled: true,
      },
    ],
  },
];

export const propertyDamageLayout = [
  {
    row: [
      {
        label: "Preapproved Medical Amount:",
        name: "providerMax",
        type: "number",
        required: false,
      },
      {
        label: "Moving Violation:",
        name: "movingViolation",
        type: "text",
        required: false,
      },
    ],
  },
  {
    row: [
      {
        label: "Property Damage Severity:",
        name: "propertyDamageSeverity",
        type: "select",
        required: false,
        optionsURL:
          "field_options/?content_type=case&field_name=property_damage_severity&ordering=order&",
      },
      {
        label: "Property Damage Cost:",
        name: "propertyDamageAmount",
        type: "number",
        required: false,
      },
    ],
  },
  {
    row: [
      {
        label: "Police Report Number:",
        name: "policeReportNumber",
        type: "text",
        required: false,
      },
    ],
  },
];

// TODO: Needs some adjustments
export const litigationLayout = [
  {
    row: [
      {
        label: "Litigation Law Firm",
        name: "litigationLawFirm",
        type: "text",
        required: false,
      },
      {
        label: "Litigation Attorney",
        name: "litigationAttorney",
        type: "text",
        required: false,
      },
    ],
  },
  {
    row: [
      {
        label: "Phone Number",
        name: "litigationPhone",
        type: "text",
        required: false,
      },
      {
        label: "Email",
        name: "litigationEmail",
        type: "text",
        required: false,
      },
    ],
  },
  {
    row: [
      {
        label: "Address",
        name: "litigationAddress",
        type: "text",
        required: false,
      },
    ],
  },
];

export default null;
